import site from '../content/siteContent.json';
import serviceAreas from '../content/serviceAreas.json';
import { businessInfo } from '../mockData';

export const SITE_ORIGIN = new URL(site.site).origin;
export const LOCAL_BUSINESS_ID = `${SITE_ORIGIN}/#localbusiness`;
export const BUSINESS_PROVIDER = { '@id': LOCAL_BUSINESS_ID };
export const BUSINESS_LOGO_URL = `${SITE_ORIGIN}/logo.png?v=badge-e75c0e4c89f4`;

// These are service destinations, not additional branches or business offices.
// The production build checks this list against the active location records.
export const SERVICE_LOCATIONS = serviceAreas;

export const getAreaServed = (locations = SERVICE_LOCATIONS) =>
  locations.filter(location => location.active !== false).map(location => ({
    '@type': 'Place',
    name: location.city,
    ...(location.state ? {
      containedInPlace: { '@type': 'State', name: location.state },
    } : {}),
  }));

const phone = String(businessInfo.phone1).replace(/[^+\d]/g, '')
  .replace(/^(\d{10})$/, '+91$1');

// One complete entity is shared by the initial HTML and the interactive page.
// Individual services reference its @id instead of creating partial businesses.
export const localBusinessSchema = {
  '@type': ['TravelAgency', 'LocalBusiness'],
  '@id': LOCAL_BUSINESS_ID,
  name: businessInfo.name,
  alternateName: 'VVPSS Taxi Services Satna',
  url: `${SITE_ORIGIN}/`,
  telephone: phone,
  email: businessInfo.email,
  logo: { '@type': 'ImageObject', url: BUSINESS_LOGO_URL },
  image: BUSINESS_LOGO_URL,
  foundingDate: businessInfo.established,
  priceRange: '₹₹',
  description: site.bookingServicesSummary,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Beside Sanyasi Baba, Ward 31, Jawahar Nagar',
    addressLocality: 'Satna',
    addressRegion: 'Madhya Pradesh',
    postalCode: '485001',
    addressCountry: 'IN',
  },
  hasMap: 'https://share.google/OqglooUbojgKZZHMB',
  sameAs: ['https://share.google/OqglooUbojgKZZHMB'],
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    opens: '00:00',
    closes: '23:59',
  },
  areaServed: getAreaServed(),
  knowsLanguage: ['Hindi', 'English'],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: phone,
    contactType: 'booking enquiries',
    availableLanguage: ['Hindi', 'English'],
  },
};
